<template>
  <v-card color="primary" dark class="mb-6 pa-2 mx-auto" max-width="300" min-height="150" flat>
    <v-card-title v-html="title"></v-card-title>
    <v-card-text v-html="text"></v-card-text>
    <v-card-actions>
      <v-btn color="accent" dark :href="link" block depressed>
        Subscribe
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  export default {
    name: 'EmailWidget',

    props: {
      title: {
        type: String,
        default: 'Get our free daily email'
      },
      text: {
        type: String,
        default: 'Sign up to get the day\'s essential news and analysis in your inbox each morning.'
      },
      link: {
        type: String,
        default: '/daily-email'
      }
    }
  }
</script>

<style lang="sass" scoped>
  .v-card__title
    word-break: initial
    font-size: 1rem
    line-height: 1.5rem
</style>